
  <ng-template #operatorView>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ng-template>

  <ng-template #customerView>
    <main id="profile">
      <div class="card">
        <div class="card-header">
          <h5>
            <app-svg source="icons/feather/user" height="18" i18n="@@InvoicePricingHeader" class="mb-1 p-0"></app-svg><span i18n="@@ProfileTab" class="ms-2">Profil</span>
          </h5>
          </div>
          <div *ngIf="isLoading" class="loading-spinner-container">
            <div class="spinner-border text-primary loading-spinner-md" role="status">
              <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
            </div>
          </div>
          <div class="card-body" *ngIf="!isLoading">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
        </div>
    </main>
  </ng-template>

  <ng-template #userView>
    <main id="profile">
      <div class="card">
        <nav>
          <div class="nav-tab" id="nav-tab" role="tablist">
            <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
              <li class="nav-item" [ngbNavItem]="'summary'" domId="tab_profile">
                <a class="nav-link me-2 ps-2" ngbNavLink disabled>
                  <app-svg source="icons/feather/settings" height="18"></app-svg>
                  <span i18n="@@ProfileTab">Profil</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div *ngIf="isLoading" class="loading-spinner-container">
          <div class="spinner-border text-primary loading-spinner-md" role="status">
            <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
          </div>
        </div>
        <div class="card-body" *ngIf="!isLoading">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      </div>
    </main>
  </ng-template>

  <ng-template #checkIcon>
    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  </ng-template>
  <ng-template #minusIcon>
    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="8" y1="12" x2="16" y2="12"></line>
    </svg>
  </ng-template>
  <ng-template #questionIcon>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  </ng-template>

  <ng-template #content>
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formCreated">
      <div class="tab-pane fade active show">
        <app-message [service]="messageService"></app-message>
        <div class="row">
          <div class="col-12 col-xxl-4 col-lg-6 order-first">
            <h5 i18n="@@PersonalInformationHeader" class="border-bottom pb-2">
              Persönliche Informationen
              <span class="float-end">
                <span class="badge bg-primary">{{ userProfile?.typeDisplay }}</span>
              </span>
            </h5>
            <div class="form-group mb-2">
              <div *ngIf="isTypeCompany();" class="form-group">
                <label for="company" i18n="@@CompanyLabel">Unternehmen*</label>
                <input type="text" class="form-control" id="company" formControlName="company" placeholder="Unternehmen*" />

                <div class="error">
                  <em *ngIf="formService.validateControl('company') && formService.hasError('company', 'required')" i18n="@@CompanyRequiredError">Unternehmen wird benötigt</em>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <div *ngIf="isOperatorView && isTypeCompany()" class="form-group">
                <label for="company" i18n="@@CompanyLabel">Interne Bezeichnung</label>
                <input type="text" class="form-control" id="company" formControlName="internalDescription" placeholder="Interne Bezeichnung" />
              </div>

            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-7">
                <div class="form-group mb-2">
                  <label for="gender" i18n="@@TitleLabel">Anrede*</label>
                  <select id="gender" formControlName="gender" class="form-control form-select">
                    <option value="" disabled selected hidden i18n="@@TitleOptionPlaceholder">Anrede*</option>
                    <option value="male" i18n="@@TitleMrOption">Herr</option>
                    <option value="female" i18n="@@TitleMs_MrsOption">Frau</option>
                    <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
                  </select>
                  <div class="error">
                    <em *ngIf="formService.validateControl('gender') && formService.hasError('gender', 'required')" i18n="@@TitleRequiredError">Anrede wird benötigt</em>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label for="fistName" i18n="@@FirstnameLabel">Vorname*</label>
                  <input type="text" class="form-control" id="firstName" formControlName="firstName" i18n-placeholder="@@FirstnamePlaceholder" placeholder="Vorname*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')" i18n="@@FirstnameRequiredError">Vorname wird benötigt</em>
                    <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                    <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'maxlength')" i18n="@@ExceededMaxLengthError">Die Eingabe darf maximal 50 Zeichen lang sein</em>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label for="lastName" i18n="@@LastnameLabel">Nachname*</label>
                  <input type="text" class="form-control" id="lastName" formControlName="lastName" i18n-placeholder="@@LastnamePlaceholder" placeholder="Nachname*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')" i18n="@@LastnameRequiredError">Nachname wird benötigt</em>
                    <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                    <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'maxlength')" i18n="@@ExceededMaxLengthError">Die Eingabe darf maximal 50 Zeichen lang sein</em>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-5 order-first order-md-last">
                <div class="row">
                  <div class="col-8">
                    <div class="mb-2 text-center">
                      <div class="picture-container mt-4">
                        <div class="profilepic">
                          <img class="profilepic__image picture-src" [src]="picture" alt="Profibild" />
                          <div class="profilepic__content" (click)="file.click()">
                            <span class="profilepic__icon"><i class="fa fa-camera"></i></span>
                            <span class="profilepic__text">Bild ändern</span>
                          </div>
                        </div>
                        <input type="file" id="profilePicture" (change)="fileChangeEvent($event)" [disabled]="isSupporter" #file class="d-none" />

                        <image-cropper [imageChangedEvent]="imageChangedEvent"
                                       [maintainAspectRatio]="true"
                                       [aspectRatio]="4 / 4"
                                       [resizeToWidth]="256"
                                       [hidden]="!isCropping"
                                       format="png"
                                       (imageCropped)="imageCropped($event)"
                                       (imageLoaded)="imageLoaded()"
                                       (cropperReady)="cropperReady()"
                                       (loadImageFailed)="loadImageFailed()"></image-cropper>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mt-3" role="group" aria-label="">
                      <button class="btn btn-danger mb-2"
                              id="delete_profile_pic"
                              (click)="removeProfilePicture(formService.form.value)"
                              i18n="@@DeletePictureButton"
                              [disabled]="!userProfile?.pictureUri || isSupporter">
                        <app-svg source="icons/feather/trash" height="18"></app-svg>
                      </button>

                      <button class="btn btn-yellow ms-1"
                              *ngIf="isCropping"
                              id="save_profile_pic"
                              (click)="isCropping = false"
                              i18n="@@SavePictureHeader">
                        <app-svg source="icons/feather/check" height="18"></app-svg>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div formGroupName="address">
              <div class="row">
                <div class="col-8 mb-2">
                  <label for="street" i18n="@@StreetLabel">Straße*</label>
                  <input type="text" class="form-control" id="street" formControlName="street" placeholder="Straße*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'required')" i18n="@@StreetRequiredError">Straße wird benötigt</em>
                    <em *ngIf="formService.validateControl('address.street') && formService.hasError('address.street', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                  </div>
                </div>
                <div class="col-4 mb-2">
                  <label for="houseNumber" i18n="@@HousnumberLabel">Nr.*</label>
                  <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control" placeholder="Nr.*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('address.houseNumber') && formService.hasError('address.houseNumber', 'required')" i18n="@@HousnumberRequiredError">Hausnummer wird benötigt</em>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4 mb-2">
                  <label for="postalCode" i18n="@@postalCodeLabel">PLZ*</label>
                  <input type="text" id="postalCode" formControlName="postalCode" class="form-control" placeholder="PLZ*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'required')" i18n="@@postalCodeRequiredError">PLZ wird benötigt</em>
                    <em *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                    <em *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'maxlength')" i18n="@@ExceededMaxLengthPLZError">Die Eingabe darf maximal 5 Zeichen lang sein</em>
                    <em *ngIf="formService.validateControl('address.postalCode') && formService.hasError('address.postalCode', 'minlength')" i18n="@@MissingNumbersPLZError">PLZ zu kurz</em>
                  </div>
                </div>

                <div class="col-8 mb-2">
                  <label for="city" i18n="@@LocationLabel">Ort*</label>
                  <input type="text" id="city" formControlName="city" class="form-control" placeholder="Ort*" />
                  <div class="error">
                    <em *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'required')" i18n="@@LocationRequiredError">Ort wird benötigt</em>
                    <em *ngIf="formService.validateControl('address.city') && formService.hasError('address.city', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="phone" i18n="@@PhoneLabel">Telefon*</label>
              <input type="text" id="phone" formControlName="phone" class="form-control" placeholder="Telefon*" [ngClass]="{ 'is-invalid': formService.validateControl('phone') }" />
              <div class="error">
                <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'required')" i18n="@@PhonenumberRequiredError">Telefonnummer wird benötigt</em>
                <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
                <em *ngIf="formService.validateControl('phone') && formService.hasError('phone', 'minlength')" i18n="@@MinLengthError">Telefonnummer zu kurz</em>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="email" i18n="@@EmailLabel">E-Mail-Adresse</label>
              <input type="text" [readonly]="true" id="email" class="form-control" formControlName="email" [value]="userProfile.email" i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail-Adresse" />
            </div>
          </div>
          <div class="col-12 col-xxl-4 col-lg-6 order-xxl-last pt-3 pt-lg-0" *ifRoles='["Customer", "Operator"]'>
            <h5 class="border-bottom pb-2" i18n="@@SubscribtionDetailsHeader">
              Abonnement-Details
              <span class="float-end">
                <container-element [ngSwitch]="userProfile?.subscriptionTypeId">
                  <span class="badge bg-enterprise" *ngSwitchCase="4">Enterprise</span>
                  <span class="badge bg-premium" *ngSwitchCase="3">Premium</span>
                  <span class="badge bg-primary" *ngSwitchCase="2">Standard</span>
                  <span class="badge bg-primary" *ngSwitchCase="1">Basic</span>
                </container-element>
              </span>
            </h5>
            <div class="mb-2 text-left fs-6">
              <dl class="row" *ngIf="!loadingSubscriptionDetails">
                <dt class="col-8 fw-bold py-1" i18n="@@Chargingstations">Ladestationen</dt>
                <dt class="col-4 fw-normal py-1" i18n="@@ChargingstationsOfAll">{{ dashboardProfile?.numberOfChargingStations }} von {{ subscriptionDetails.chargingstationsCreate}}</dt>
                <dt class="col-8 fw-bold py-1" i18n="@@ChargingGroups">Ladegruppen</dt>
                <dt class="col-4 fw-normal py-1" i18n="@@ChargingGroupsOfAll">{{ dashboardProfile?.numberOfChargingStationGroups }} von {{ subscriptionDetails.chargingstationGroupsCreate}}</dt>
                <dt class="col-8 fw-bold py-1" i18n="@@Users">Benutzer</dt>
                <dt class="col-4 fw-normal py-1" i18n="@@UsersOfAll">{{ dashboardProfile?.numberOfUsers }} von {{ subscriptionDetails.manageUsersCreateCount}}</dt>
              </dl>
              <h6 class="fw-bold border-bottom pb-2 mb-2" i18n="@@AdditionalFeatures">Zusätzliche Funktionen</h6>
              <dl class="row">
                <dt class="col-8 fw-bold py-1" i18n="@@DeliveryNoteCreatingFeature">Lieferscheinerstellung</dt>
                <dt class="col-4 fw-normal py-1">
                  <ng-container *ngIf="permissions.createDeliveryNotes; else minusIcon">
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </ng-container>
                  <ng-template #minusIcon>
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </ng-template>
                </dt>
                <dt class="col-8 fw-bold py-1" i18n="@@FreeChargeFeature">FreeCharge</dt>
                <dt class="col-4 fw-normal py-1">
                  <ng-container *ngIf="permissions.chargingstationFreecharge; else minusIcon">
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </ng-container>
                  <ng-template #minusIcon>
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </ng-template>
                </dt>
                <dt class="col-8 fw-bold py-1" i18n="@@GroupingFeature">Gruppierungsfunktion</dt>
                <dt class="col-4 fw-normal py-1">
                  <ng-container *ngIf="permissions.chargingstationsGroups; else minusIcon">
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </ng-container>
                  <ng-template #minusIcon>
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </ng-template>
                </dt>
                <dt class="col-8 fw-bold py-1" i18n="@@RemoteStartFeature">Ladevorgang manuell freigeben</dt>
                <dt class="col-4 fw-normal py-1">
                  <ng-container *ngIf="permissions.chargingstationRemoteStart; else minusIcon">
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </ng-container>
                  <ng-template #minusIcon>
                    <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </ng-template>
                </dt>
                <!-- <dt class="col-8 fw-bold py-1">Public Charge</dt>
        <dt class="col-4 fw-normal py-1">
          <ng-container *ngIf="permissions.chargingstationFreecharge && hasStripeAccount; else minusIcon">
            <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </ng-container>
          <ng-template #minusIcon>
            <svg xmlns="http://wwww.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle text-secondary">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </ng-template>
        </dt> -->
              </dl>
              <!-- <p *ngIf="userProfile.endDate" i18n="@@SubscriptionExpireMessage">Ihr Abonnement läuft am {{ userProfile.endDate | dateDE }} ab.</p> -->
            </div>
          </div>
          <div class="col-12 col-lg-12 col-xxl-4 pt-3 pt-xxl-0">
            <div *ngIf="pricing">
              <div *ifRoles='["User"]'>

                <div *ngIf="!pricing">
                  <h5 i18n="@@SubscriptionDetailsHeader" class="border-bottom pb-2">
                    Abrechnung
                  </h5>
                  <div class="text-center">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="pricing && pricing.billingMethod == 'Manual'">
                  <h5 i18n="@@SubscriptionDetailsHeader" class="border-bottom pb-2">
                    Abrechnung
                  </h5>

                  <article class="pricing">
                    <p i18n="@@YourPricingInThisPark">Ihr Tarif in diesem Ladepark:</p>
                    <h2 i18n="@@PricingName" class="m-0"><strong>{{ pricing.name }}</strong></h2>
                    <p class="price mb-0" i18n="@@CurrencyUnit"><strong>{{ pricing.price | currency:'EUR' }}</strong> pro kWh - AC</p>
                    <p class="price" i18n="@@CurrencyUnit"><strong>{{ pricing.priceDc | currency:'EUR' }}</strong> pro kWh - DC</p>
                    <p i18n="@@PricingDescription" *ngIf="pricing.description">{{ pricing.description }}</p>
                    <p class="mb-0">Monatlich abgerechnet je nach Nutzung. Die Berechnung erfolgt in Wh. 1 kWh entspricht 1000 Wh.</p>
                  </article>

                </div>

                <div class="mb-2 text-left fs-6" *ngIf="pricing && pricing.billingMethod == 'Automatic'">
                  <h5 i18n="@@SubscriptionDetailsHeader" class="border-bottom pb-2">
                    Abrechnung
                  </h5>
                  <div *ngIf="stripeInfo.stripePaymentMethodId != null">
                    <p i18n="@@PaymentMethodDescription">
                      Ihre Zahlungsmethode ermöglicht die monatliche automatische Abrechnung Ihrer Ladevorgänge in diesem Ladepark.
                    </p>

                    <a class="btn btn-yellow me-1" id="charging_park_subcription"
                       [routerLink]="['charging-park-subscription']"
                       i18n="@@PaymentMethodButtonManage">Zahlungsmethode bearbeiten</a>

                    <a class="btn btn-danger ms-1" id="cancel_subcription_to_charging_park"
                       (click)="showConfirmRemovePaymentMethodDialog()"
                       i18n="@@PaymentMethodButtonDelete">Zahlungsmethode entfernen</a>
                  </div>

                  <div *ngIf="stripeInfo.stripePaymentMethodId == null && !isRedirectedFromPaypal">
                    <p i18n="@@PaymentMethodInfo">Um die Nutzung der Ladestationen zu erleichtern, verwendet dieser Ladepark die automatische monatliche Abrechnung.</p>
                    <p i18n="@@PaymentMethodCTA">Bitte geben Sie eine Zahlungsmethode an, damit wir die anfallenden Kosten für das Laden Ihres Elektrofahrzeugs jeden Monat automatisch von Ihrem Konto abbuchen können.</p>

                    <a class="btn btn-yellow" id="charging_park_subcription"
                       [routerLink]="['charging-park-subscription']" [disabled]="pricing.price == 0"
                       i18n="@@PaymentMethodButtonCreate">Zahlungsmethode erstellen</a>
                  </div>
                  <div *ngIf="stripeInfo.stripePaymentMethodId == null && isRedirectedFromPaypal" class="alert alert-success">
                    <p i18n="@@PaymentMethodSuccessMessage">Die PayPal-Zahlungsmethode wurde erfolgreich konfiguriert. Sie können die Seite neu laden, um die Zahlungsmethode zu bearbeiten.</p>
                  </div>

                  <article class="pricing">
                    <p i18n="@@YourPricingInThisPark">Ihr Tarif in diesem Ladepark:</p>
                    <h2 i18n="@@PricingName" class="m-0"><strong>{{ pricing.name }}</strong></h2>
                    <p class="price mb-0" i18n="@@CurrencyUnit"><strong>{{ pricing.price | currency:'EUR' }}</strong> pro kWh - AC</p>
                    <p class="price" i18n="@@CurrencyUnit"><strong>{{ pricing.priceDc | currency:'EUR' }}</strong> pro kWh - DC</p>
                    <p i18n="@@PricingDescription" *ngIf="pricing.description">{{ pricing.description }}</p>
                    <p class="mb-0">Monatlich abgerechnet je nach Nutzung. Die Berechnung erfolgt in Wh. 1 kWh entspricht 1000 Wh.</p>
                  </article>
                </div>
              </div>
            </div>
            <h5 i18n="@@ProfileSettingsHeader" class="border-bottom pb-2">Einstellungen</h5>
            <div class="row mb-3" formGroupName="settings">
              <h6 class="fw-bold" i18n="@@ProfileNotificationsHeader">Benachrichtigungen</h6>
              <div class="text-muted mb-2" i18n="@@ProfileNotificationsDescription">
                Hier können Sie einstellen, bei welchen Ereignissen Sie eine Benachrichtigung per E-Mail erhalten wollen.
              </div>
              <div class="mb-2 mt-3">
                <div class="form-check mb-3">
                  <input class="form-check-input" type="checkbox" id="acceptAd" formControlName="acceptAd" />
                  <label class="form-check-label" for="acceptAd" i18n="@@acceptAdLabel">Newsletter</label>
                  <div class="form-text" i18n="@@acceptAdDescription">Sie erhalten neue Informationen über die Produkte der CUBOS Service GmbH. </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-block w-100 d-md-none pt-3">
            <div class="d-flex flex-column justify-content-center" style="gap: 0.5rem">
              <button type="submit" id="save_changes_mobile" class="btn btn-save" [disabled]="(!(formService.form.valid && formService.form.dirty)) || isSupporter" i18n="@@SaveChangesButton">Änderung speichern</button>
              <button *ngIf="!this.isUserProfile" type="button" [disabled]="isSupporter" id="change_password_mobile" class="btn btn-warning" (click)="isOperatorView && !this.isUserProfile ? openChangePasswordForCustomerDialog() : openChangePasswordDialog()" i18n="@@ChangePasswortButton">Passwort ändern</button>
              <div class="btn-group" *ngIf="!userProfile.emailConfirmed"><button type="button" [disabled]="isSupporter" class="btn btn-yellow" *ifRoles='["Operator"]' (click)="confirmEmailForCustomer();" i18n="@@ConfirmEmailButton">E-Mail-Adresse bestätigen</button></div>
              <!-- <div class="btn-group" *ngIf="userProfile.emailConfirmed"><button type="button" class="btn btn-yellow" [disabled]="userProfile.emailConfirmed" *ifRoles='["Operator"]' i18n="@@ConfirmEmailDisabledButton">E-Mail-Adresse ist bestätigt</button></div> -->
              <button type="button" [disabled]="isSupporter" id="invite_customer_mobile" *ngIf="!userProfile.emailConfirmed" class="btn btn-yellow" (click)="openInviteCustomerDialog()" i18n="@@InviteCustomerButton">Kundeneinladung versenden</button>
              <button type="button" [disabled]="isSupporter" id="delete_account_mobile" class="btn btn-danger" (click)="isOperatorView ? openDeleteUserForCustomerDialog() : openDeleteProfileDialog()" i18n="@@DeleteCustomerAccountButton"><app-svg source="icons/feather/trash" height="18"></app-svg><span>&ensp;Konto löschen</span></button>
            </div>
          </div>
          <div class="col-12 d-none d-md-inline mt-2">
            <div class="float-start me-2 d-flex justify-content-between" style="gap: 0.8rem">
              <button [disabled]="isSupporter" type="button" id="delete_account" class="btn btn-danger" (click)="isOperatorView ? openDeleteUserForCustomerDialog() : openDeleteProfileDialog()" i18n="@@DeleteCustomerAccountButton"><app-svg source="icons/feather/trash" height="18"></app-svg><span>&ensp;Konto löschen</span></button>
              <button *ngIf="!this.isUserProfile" type="button" [disabled]="isSupporter" id="change_password" class="btn btn-warning" (click)="isOperatorView ? openChangePasswordForCustomerDialog() : openChangePasswordDialog()" i18n="@@ChangePasswortButton">Passwort ändern</button>
              <button type="button" [disabled]="isSupporter" id="change_emailadr" class="btn btn-warning" (click)="openChangeEmailAdrDialog()">E-Mail ändern</button>
              <button *ngIf="!userProfile.emailConfirmed && roles==Operator" [disabled]="isSupporter" type="button" id="confirm_email" class="btn btn-yellow" (click)="confirmEmailForCustomer();" i18n="@@ConfirmEmailButton">E-Mail-Adresse bestätigen</button>
              <button *ngIf="roles==Operator && !userProfile.emailConfirmed" [disabled]="isSupporter" type="button" id="invite_customer" class="btn btn-yellow" (click)="openInviteCustomerDialog()" i18n="@@InviteCustomerButton">Kundeneinladung versenden</button>
            </div>
            <div class="float-end">
              <button type="submit" id="save_changes" class="btn btn-save" [disabled]="!(formService.form.valid && formService.form.dirty)" i18n="@@SaveChangesButton">Änderungen speichern</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-container *ngTemplateOutlet="templateView"></ng-container>

  <router-outlet></router-outlet>
